import { useMemo } from "react";
import useAuth from "../../../shared/lib/hooks/useAuth";
// eslint-disable-next-line boundaries/element-types
import { useGetAppUserResourceIdQuery } from "../../account/appUsersResource/redux/appUsersResource.api";
import useCompanyTimeZone from "./useCompanyTimeZone";
import { getBrowserTimeshift } from '../../../shared/utils/timezones';

const useTimeZone = () => {
  const companyTimeZone = useCompanyTimeZone();

  const { user: userCurrent } = useAuth();

  const {
    data: dataAppUserResourceId,
  } = useGetAppUserResourceIdQuery({
    id: userCurrent?.appUserId,
  });

  const browserTimeZone = getBrowserTimeshift();

  return useMemo(() => {
    const userTimeZone = dataAppUserResourceId?.data
      ?.customAugmentationEx?.general?.timeZone;

    return userTimeZone || companyTimeZone || browserTimeZone;
  }, [companyTimeZone, dataAppUserResourceId, browserTimeZone]);
};

export default useTimeZone;
